import React from "react";

import MySelect from "./MySelect.js";



export default class Input extends React.Component {



  state = {

    selectedOption: null,

  };

  handleChange = selectedOption => {

    this.setState({ selectedOption });

    this.props.onChangeMulti(this.props.nazwa, selectedOption);

  };



  render() {



  const label = this.props.longname !== null ? this.props.longname : this.props.nazwa;

  const { selectedOption } = this.state;



  // if(this.props.type === 4 && this.props.rodzaj === 1) {

  //   return(<>

  //     {this.props.wymagane.length > 0 ? (<><label htmlFor={this.props.idx}>{label} <span>( Wymagane pola: {this.props.wymagane.map(nazwa => { return <span> {nazwa}, </span> })} )</span></label></>) : (<><label htmlFor={this.props.idx}>{label}</label></>) }

  //     <select className="form-control" onChange={(e) => (this.props.onChangeRequired(e, this.props.nazwa, e.target.value))}>

  //       <option value={null} hidden>Wybierz</option>

  //       {this.props.Optional ? (<option value={null} >Brak wyboru</option>) : null }

  //       {this.props.params ? (this.props.params.map((data, index) => {

  //       return (<option key={index} value={data.id}>{data.name}</option>);

  //       }) ) : null }

  //     </select>

  //   </>)

  // }



  // if(this.props.type === 4 && this.props.rodzaj === 2 || this.props.type === 1 && this.props.rodzaj === 2 || this.props.type === 1 && this.props.rodzaj === 1) {

  //   return(<>

  //     {this.props.wymagane.length > 0 ? (<><label htmlFor={this.props.idx}>{label} <span>( Wymagane pola: {this.props.wymagane.map(nazwa => { return <span> {nazwa}, </span> })} )</span></label></>) : (<><label htmlFor={this.props.idx}>{label}</label></>) }

  //     <MySelect

  //     options={this.props.params}

  //     placeholder ="Wybierz..."

  //     isMulti

  //     closeMenuOnSelect={false}

  //     hideSelectedOptions={false}

  //     value={selectedOption}

  //     onChange={this.handleChange}

  //     allowSelectAll={true}

  //     getOptionLabel ={(option)=>option.name}

  //     getOptionValue ={(option)=>option.id}

  //     />

  //   </>)

  // }





  // if(this.props.type === -1) {

  //   return(<>

  //     {this.props.wymagane.length > 0 ? (<><label htmlFor={this.props.idx}>{label} <span>( Wymagane pola: {this.props.wymagane.map(nazwa => { return <span> {nazwa}, </span> })} )</span></label></>) : (<><label htmlFor={this.props.idx}>{label}</label></>) }

  //       <input className="form-control" type="text" id={this.props.idx} onChange={(e) => (this.props.onChangeInput(this.props.nazwa, 'value', e.target.value))}></input>

  //   </>)

  // }



  // if(this.props.type === 0) {

  //   return(<>

  //     {this.props.wymagane.length > 0 ? (<><label htmlFor={this.props.idx}>{label} <span>( Wymagane pola: {this.props.wymagane.map(nazwa => { return <span> {nazwa}, </span> })} )</span></label></>) : (<><label htmlFor={this.props.idx}>{label}</label></>) }

  //     <input className="form-control" type="date" id={this.props.idx} onChange={(e) => (this.props.onChangeInput(this.props.nazwa, 'value', e.target.value))}></input>

  //   </>)

  // }



  // if(this.props.type === 1) {

  //   return(<>

  //     {this.props.wymagane.length > 0 ? (<><label htmlFor={this.props.idx}>{label} <span>( Wymagane pola: {this.props.wymagane.map(nazwa => { return <span> {nazwa}, </span> })} )</span></label></>) : (<><label htmlFor={this.props.idx}>{label}</label></>) }

  //     <input className="form-control" type="number" id={this.props.idx} onChange={(e) => (this.props.onChangeInput(this.props.nazwa, 'value', e.target.value))}></input>

  //   </>)

  // }



  // if(this.props.type === 2) {

  //   return(<>

  //     {this.props.wymagane.length > 0 ? (<><label htmlFor={this.props.idx}>{label} <span>( Wymagane pola: {this.props.wymagane.map(nazwa => { return <span> {nazwa}, </span> })} )</span></label></>) : (<><label htmlFor={this.props.idx}>{label}</label></>) }

  //     <input className="form-control" type="number" id={this.props.idx} onChange={(e) => (this.props.onChangeInput(this.props.nazwa, 'value', e.target.value))}></input>

  //   </>)

  // }



  // if(this.props.type === 3) {

  //   return(<>

  //     {this.props.wymagane.length > 0 ? (<><label htmlFor={this.props.idx}>{label} <span>( Wymagane pola: {this.props.wymagane.map(nazwa => { return <span> {nazwa}, </span> })} )</span></label></>) : (<><label htmlFor={this.props.idx}>{label}</label></>) }

  //     <input className="form-control" type="number" id={this.props.idx} onChange={(e) => (this.props.onChangeInput(this.props.nazwa, 'value', e.target.value))}></input>

  //   </>)

  // }



  // if(this.props.type === 4 && this.props.rodzaj === -1) {

  //   return(<>

  //     {this.props.wymagane.length > 0 ? (<><label htmlFor={this.props.idx}>{label} <span>( Wymagane pola: {this.props.wymagane.map(nazwa => { return <span> {nazwa}, </span> })} )</span></label></>) : (<><label htmlFor={this.props.idx}>{label}</label></>) }

  //     <input className="form-control" type="text" id={this.props.idx} onChange={(e) => (this.props.onChangeInput(this.props.nazwa, 'Value', e.target.value))}></input>

  //   </>)

  // }


  // <--NOWA WERSJA-->

  if(this.props.rodzaj === 0) {
    return(<>

      {this.props.wymagane.length > 0 ? (<><label htmlFor={this.props.idx}>{label} <span>( Wymagane pola: {this.props.wymagane.map(nazwa => { return <span> {nazwa}, </span> })} )</span></label></>) : (<><label htmlFor={this.props.idx}>{label}</label></>) }

      <input className="form-control" type="date" id={this.props.idx} onChange={(e) => (this.props.onChangeRequired(e, this.props.nazwa, e.target.value))}></input>

    </>)
  }

  else if(this.props.rodzaj === -1) {
    if(this.props.type === 0) {
      return(<>
        {this.props.wymagane.length > 0 ? (<><label htmlFor={this.props.idx}>{label} <span>( Wymagane pola: {this.props.wymagane.map(nazwa => { return <span> {nazwa}, </span> })} )</span></label></>) : (<><label htmlFor={this.props.idx}>{label}</label></>) }
        <input className="form-control" type="date" id={this.props.idx} onBlur={(e) => (this.props.onChangeRequired(e, this.props.nazwa, e.target.value))}></input>
      </>)
    }
    else if (this.props.type === 1) {
      return(<>
        {this.props.wymagane.length > 0 ? (<><label htmlFor={this.props.idx}>{label} <span>( Wymagane pola: {this.props.wymagane.map(nazwa => { return <span> {nazwa}, </span> })} )</span></label></>) : (<><label htmlFor={this.props.idx}>{label}</label></>) }
        <input className="form-control" type="number" step="1" id={this.props.idx} onBlur={(e) => (this.props.onChangeRequired(e, this.props.nazwa, e.target.value))}></input>
        </>)
    }
    else if (this.props.type === 2 || this.props.type === 3) {
      return(<>
        {this.props.wymagane.length > 0 ? (<><label htmlFor={this.props.idx}>{label} <span>( Wymagane pola: {this.props.wymagane.map(nazwa => { return <span> {nazwa}, </span> })} )</span></label></>) : (<><label htmlFor={this.props.idx}>{label}</label></>) }
        <input className="form-control" type="number" id={this.props.idx} onBlur={(e) => (this.props.onChangeRequired(e, this.props.nazwa, e.target.value))}></input>
        </>)
    }
    else if(this.props.type === 4 || this.props.type === -1) {
      return(<>
        {this.props.wymagane.length > 0 ? (<><label htmlFor={this.props.idx}>{label} <span>( Wymagane pola: {this.props.wymagane.map(nazwa => { return <span> {nazwa}, </span> })} )</span></label></>) : (<><label htmlFor={this.props.idx}>{label}</label></>) }
        <input className="form-control" type="text" id={this.props.idx} onBlur={(e) => (this.props.onChangeRequired(e, this.props.nazwa, e.target.value))}></input>
      </>)
    } else { return null }
    
  }
  else if (this.props.rodzaj === 1) {
    return(<>
      {this.props.wymagane.length > 0 ? (<><label htmlFor={this.props.idx}>{label} <span>( Wymagane pola: {this.props.wymagane.map(nazwa => { return <span> {nazwa}, </span> })} )</span></label></>) : (<><label htmlFor={this.props.idx}>{label}</label></>) }
      <select className="form-control" onChange={(e) => (this.props.onChangeRequired(e, this.props.nazwa, e.target.value))}>
        <option value={null} hidden>Wybierz</option>
        {this.props.Optional ? (<option value={null} >Brak wyboru</option>) : null }
        {this.props.params ? (this.props.params.map((data, index) => {
        return (<option key={index} value={data.id}>{data.name}</option>);
        }) ) : null }
      </select>
    </>)
  }
  else if (this.props.rodzaj === 2) {
    return(<>

      {this.props.wymagane.length > 0 ? (<><label htmlFor={this.props.idx}>{label} <span>( Wymagane pola: {this.props.wymagane.map(nazwa => { return <span> {nazwa}, </span> })} )</span></label></>) : (<><label htmlFor={this.props.idx}>{label}</label></>) }

      <MySelect

      options={this.props.params}

      placeholder ="Wybierz..."

      isMulti

      closeMenuOnSelect={false}

      hideSelectedOptions={false}

      value={selectedOption}

      onChange={this.handleChange}

      allowSelectAll={true}

      getOptionLabel ={(option)=>option.name}

      getOptionValue ={(option)=>option.id}

      />

    </>)
  }
  else {

    return <p>Brak typu</p>

  }



  }

  }